import React, { useEffect, useRef } from 'react';
import Lenis from 'lenis';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const lenisStyle = `
  html.lenis, html.lenis body {
    height: auto;
  }
  .lenis.lenis-smooth {
    scroll-behavior: auto !important;
  }
  .lenis.lenis-smooth [data-lenis-prevent] {
    overscroll-behavior: contain;
  }
  .lenis.lenis-stopped {
    overflow: hidden;
  }
  .lenis.lenis-scrolling iframe {
    pointer-events: none;
  }
`;

const SmoothScroll = ({ children }) => {
  const lenisRef = useRef(null);

  useEffect(() => {
    // Ultra-luxurious, very floaty smooth scroll
    const lenis = new Lenis({
      lerp: 0.05, // Lower = smoother and more floaty
      smoothWheel: true,
      wheelMultiplier: 0.8, // Slightly softer mouse wheel steps
      touchMultiplier: 1.5,
    });
    lenisRef.current = lenis;

    // Sync GSAP ScrollTrigger
    lenis.on('scroll', ScrollTrigger.update);

    // Standard animation frame loop
    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);

    // Prevent GSAP lag smoothing conflict
    gsap.ticker.lagSmoothing(0);

    return () => {
      // Clean up safely
      cancelAnimationFrame(rafId);
      if (lenisRef.current) {
        lenisRef.current.destroy();
        lenisRef.current = null;
      }
    };
  }, []);

  return (
    <>
      <style>{lenisStyle}</style>
      {children}
    </>
  );
};

export default SmoothScroll;
